import React, { FC, ReactNode } from 'react';
import './ViewButton.css';
import { FaEye } from '@/Shared/Lib/UI/Icons';
import { ActionButton } from '..';

interface ViewButtonProps {
	onClick: () => void;
	label?: string;
	icon?: ReactNode;
	isLoading?: boolean;
	showLabel? : boolean
}

const ViewButton: FC<ViewButtonProps> = ({ onClick, label, icon = <FaEye />, isLoading, showLabel = false }) => (
	<ActionButton
		classNames="ViewButton"
		icon={icon}
		label={label}
		onClick={onClick}
		isLoading={isLoading}
		showLabel={showLabel}
	/>
);

export default ViewButton;
